import React, { useEffect, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useCompany } from 'components/hooks';
import { HeadlinePage } from 'components/common';
import { useTranslation } from 'react-i18next';
import { companyPolicies } from 'helpers';
import { useStyle } from './styles';
import { Input } from 'components/layout';
import {
  Paper,
  Grid,
  CircularProgress,
  Backdrop,
  Button,
  Typography
} from '@mui/material';
import { ROUTES } from 'consts';

export default function CompanyFormDumb({ defaultValues, handleOnSubmit, isEdit }) {
  const { isLoaded } = useCompany();
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, reset, control } = methods;

  const fields = [
    { policy: companyPolicies.name },
    { policy: companyPolicies.description },
  ];

  useEffect(() => {
    if (isEdit) reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.post || isLoaded.put}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={isEdit ? 'companyEdit.headline' : 'companyCreate.headline'} goBack={ROUTES.COMPANY_LIST}/>
      <Paper className={classes.paperStyle}>
        <FormProvider { ...methods }>
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Typography variant="h6" sx={{ padding: '8px 0px' }}>
              {t('companyList.form.title')}
            </Typography>

            <Grid container spacing={2}>
              {fields.map((field) => (
                <Grid item xs={12} sm={12} md={6} lg={6} key={field.policy.id}>
                  <Input
                    {...field.policy}
                    control={control}
                    options={field.options}
                    sx={{ width: '100%' }}
                  />
                </Grid>
              ))}
            </Grid>

            <Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} type='submit'>
                  {isEdit ? t('companyEdit.components.submit') : t('companyCreate.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
          </form>
        </FormProvider>
      </Paper>
    </>
  );
}
